
<template>
  <div class="risksResults">
    <van-nav-bar
      left-arrow
      title="天安金交中心 - 用户风险评测"
      @click-left="goableBack()"
      :z-index="10"></van-nav-bar>

    <div class="results-icon">
      <img class="" src="../../assets/img/risks/u0506.png" />
    </div>
    <div class="results-score">评测得分 : {{ score }}分</div>
    <div class="results">评测结果 : {{ resultTxt }}</div>
    <!-- <div class="risk-level">适合你的风险等级为低风险-中风险</div> -->
    <div class="risk-desc">
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;为保障投资者购买合适的金融资产，天安金交中心通过对投资者个人及财务状况、投资经验、风险偏好和风险承受能力等方面进行评测，将投资者风险承受能力由低到高分为保守型、稳健型、平衡型、积极型、进取型五种类型。
      </p>
      <p>
        &nbsp;&nbsp;&nbsp;&nbsp;风险承受能力评测问卷将在投资者首次进行投资环节进行测评，有效期一年，投资者在一年内可重新进行测评，总测评次数不超过3次（含3次）
      </p>
      <p>&nbsp;&nbsp;&nbsp;&nbsp;风险测评评分标准</p>
    </div>

    <div class="risk-table">
      <table class="table-style">
        <tr>
          <th>分数</th>
          <th>分类</th>
          <th>释义</th>
        </tr>
        <tr>
          <td>11-18分</td>
          <td>保守型</td>
          <td>风险承受能力极低</td>
        </tr>
        <!-- <tr>
           <td> 11-18分</td>
           <td>保守型</td>
           <td>风险承受能力极低</td>
         </tr> -->
        <tr>
          <td>19-26分</td>
          <td>稳健型</td>
          <td>风险承受能力较低</td>
        </tr>
        <tr>
          <td>27-33分</td>
          <td>平衡型</td>
          <td>风险承受能力一般</td>
        </tr>
        <tr>
          <td>34-40分</td>
          <td>积极型</td>
          <td>风险承受能力较高</td>
        </tr>
        <tr>
          <td>41-48 分</td>
          <td>进取型</td>
          <td>风险承受能力很高</td>
        </tr>
      </table>
    </div>
    <div class="risksResults-invest">
      <van-button type="danger" @click="goInvest">去投资</van-button>
    </div>
    <div class="re-evaluating">
      <van-button
        plain
        type="primary"
        color="#afbac5"
        @click="$router.push('questions')"
        >重新评测</van-button
      >
    </div>
  </div>
</template>

<script>
import * as UserApi from "@/api/cust"
import session from "@/utils/session"
import { NavBar, Col, Icon, Cell, Button, Toast, Dialog } from "vant"
import { mapMutations, mapGetters } from "vuex"
export default {
  components: {
    [NavBar.name]: NavBar,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      resultTxt: "",
      score: 0
    }
  },
  created() {
    this.resultTxt = this.$route.query.resultTxt
    this.score = this.$route.query.score
    UserApi.userInfo()
      .then((data) => {
        console.log("用户信息查询结果:%O", data)
        this.setUserInfo(data)
      })
      .catch((ex) => {
        Toast("用信息查询失败，请重新登陆")
        setTimeout(() => {
          this.$router.replace({
            path: "/user"
          })
        }, 2000)
      })
  },
  methods: {
    goInvest() {
      let query = session.getJson("cq")
      let external = session.get("external")
      if (!this.userInfo.isBindCard) {
        return this.$router.push({ path: "/bindcard" })
      } else {
        if (external === "1") {
          return this.$router.replace({ name: "callback", query: query })
        } else {
          if (query && query.target) {
            return this.$router.replace({ name: query.target, query: query })
          } else {
            return this.$router.replace({ name: "invest" })
          }
        }
      }
    },
    ...mapMutations(["setUserInfo"])
  },
  computed: {
    ...mapGetters(["userInfo"])
  }
}
</script>

<style lang="less" scoped>
.risksResults {
  .results-icon {
    text-align: center;
    margin-top: 30px;

    img {
      width: 60px;
    }
  }

  .results-score {
    text-align: center;
    font-size: 16px;
    color: #333;
    margin-top: 10px;
    font-weight: bold;
  }
  .results {
    text-align: center;
    font-size: 16px;
    color: #333;
    font-weight: bold;
  }

  .risk-level {
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    letter-spacing: 0px;
    color: #afbac5;
    margin-top: 18px;
  }
  .risk-table {
    margin: 0 18px;
  }
  table.table-style {
    overflow: hidden;
    width: 100%;
    border-radius: 3px;
    border-collapse: collapse;
    border-spacing: 0;
    td,
    th {
      border: 1px solid #ebeaea;
      vertical-align: center;
      text-align: center;
      line-height: 30px;
      //  font-weight: 700;
    }
    td:first-child,
    th:first-child {
      //  width: 50%;
      border-right: none;
    }
    td:last-child,
    th:last-child {
      border-left: none;
    }
    thead {
      background-color: #fff0ea;
      th {
        font-size: 13px;
        // font-weight: 600;
        color: #fd7127;
      }
    }
  }
  .risk-desc {
    margin: 15px;
    font-size: 13px;
  }

  .risksResults-invest {
    text-align: center;
    margin-top: 40px;

    button {
      width: 300px;
      height: 40px;
      background-color: #df4744;
      border-radius: 20px;
      font-size: 18px;
      color: #ffffff;
    }
  }

  .re-evaluating {
    text-align: center;
    margin-top: 15px;

    button {
      width: 300px;
      height: 40px;
      border-radius: 20px;

      font-size: 18px;
      color: #ffffff;
    }
  }
}
</style>
